import * as React from 'react';
import { canUseSymbol } from "../../utilities/index.js";
import { global, invariant, __DEV__ } from "../../utilities/globals/index.js";
var contextKey = canUseSymbol
    ? Symbol.for('__APOLLO_CONTEXT__')
    : '__APOLLO_CONTEXT__';
export function getApolloContext() {
    __DEV__ ? invariant('createContext' in React, 'Invoking `getApolloContext` in an environment where `React.createContext` is not available.\n' +
        'The Apollo Client functionality you are trying to use is only available in React Client Components.\n' +
        'Please make sure to add "use client" at the top of your file.\n' +
        'For more information, see https://nextjs.org/docs/getting-started/react-essentials#client-components') : invariant('createContext' in React, 29);
    var contextStorage = global[contextKey];
    if (!contextStorage) {
        contextStorage = global[contextKey] = new Map();
    }
    var context = contextStorage.get(React);
    if (!context) {
        context = React.createContext({});
        context.displayName = 'ApolloContext';
        contextStorage.set(React, context);
    }
    return context;
}
export var resetApolloContext = getApolloContext;
//# sourceMappingURL=ApolloContext.js.map